import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { StatusMessage } from '@hvcgroep/design-system';

import { SearchResultsInfinite } from '@uncinc/react-searchkit';
import type { InfiniteResults } from '@uncinc/react-searchkit/types';

import type { SearchVacanciesHit } from '../types';
import Hit from './Hit';

import './style.scss';
import Button from '../../Button';

const SearchVacanciesResults: React.FC<Omit<InfiniteResults, 'renderItem'>> = (props) => {
  const { className } = props;

  const { t } = useTranslation();
  const classNames = c('SearchVacancies__Results', className);

  return (
    <SearchResultsInfinite
      className={classNames}
      emptyState={(
        // @ts-expect-error
        <StatusMessage type="info">
          {t('searchkit.vacancies.no_results')}
        </StatusMessage>
      )}
      renderItem={(hit: SearchVacanciesHit) => <Hit hit={hit} />}
      // eslint-disable-next-line react/no-unstable-nested-components
      showMoreButton={(buttonProps: any) => (
        <Button
          {...buttonProps}
          type="secondary"
          icon="arrow_downward_400"
          className="d-block mx-auto"
        >
          {t('searchkit.vacancies.load_more_button')}
        </Button>
      )}
    />
  );
};

export default SearchVacanciesResults;
